<!-- <nav class="page-nav">
    <a routerLink="/about" class="page-nav-card">
        <span class="card-label">Over mij</span>
        <span class="card-title">Wie ben ik?</span>
        <span class="card-arrow">→</span>
    </a>
    <a routerLink="/classes" class="page-nav-card">
        <span class="card-label">De lessen</span>
        <span class="card-title">Wat geef ik?</span>
        <span class="card-arrow">→</span>
    </a>
    <a routerLink="/target-audience" class="page-nav-card">
        <span class="card-label">Deelnemers</span>
        <span class="card-title">Voor wie?</span>
        <span class="card-arrow">→</span>
    </a>
    <a routerLink="/offer"  class="page-nav-card page-nav-card--accent">
        <span class="card-label">Formules</span>
        <span class="card-title">Aanbod</span>
        <span class="card-arrow">→</span>
    </a>
    <a routerLink="/calendar" class="page-nav-card page-nav-card--cta">
        <span class="card-label">Inschrijven</span>
        <span class="card-title">Bekijk de agenda</span>
        <span class="card-arrow">→</span>
    </a>
</nav> -->


<footer>
    <img src="assets/images/logo.jpeg" alt="Pilates by Elisah" />
    <p class="footer-name">
        Pilates by Elisah
    </p>
    <p class="footer-sub">
        Kracht &nbsp;·&nbsp; Controle &nbsp;·&nbsp; Balans
    </p>
    <p class="footer-tagline">
        Persoonlijke Pilateslessen met aandacht voor jouw lichaam.<br>
        <a class="contact-info" href="mailto:elisah@pilatesbyelisah.be">elisah&#64;pilatesbyelisah.be</a> - <a class="contact-info" href="tel:++32472475330">+32 472 47 53 30</a>
    </p>
    <div class="footer-copy">
        <p>{{ year }} - © Pilates by Elisah</p>
        <p>Ondernemingsnummer: 0848.109.701</p>
        <p>Vestigingsadres: Heirweg Zuid 91 - 8770 Ingelmunster </p>
    </div>
    @if (version(); as buildVersion) {
        <p class="footer-version">v{{ buildVersion }}</p>
    }
</footer>